import type { DeepPartial } from '@luna/utils-ts';
import { BUNDLE_ORDER_TYPE } from '@shared/payments-types';

import type { PaymentOrders } from './PaymentOrders';

export const HU: DeepPartial<PaymentOrders> = {
    alwaysRedo: false,
    hasLegalEntityRestrictionForBundleSigning: true,
    orderBundler: {
        config: {
            DEFAULT: [
                {
                    combination: [BUNDLE_ORDER_TYPE.DOMESTIC],
                    maxSize: 5,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: false,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: false,
                },
                {
                    combination: [
                        BUNDLE_ORDER_TYPE.INTERNATIONAL,
                        BUNDLE_ORDER_TYPE.SEPA,
                        BUNDLE_ORDER_TYPE.OWN_TRANSFER,
                        BUNDLE_ORDER_TYPE.DATACARRIER,
                        BUNDLE_ORDER_TYPE.DIRECT_DEBIT,
                        BUNDLE_ORDER_TYPE.DOMESTIC_COLLECTIVE_SIGNING,
                        BUNDLE_ORDER_TYPE.DOMESTIC_COLLECTIVE_SIGNING_OPN,
                    ],
                    maxSize: 1,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: false,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: false,
                },
            ],
        },
    },
    failedOrderStates: [
        'CBB',
        'KAG',
        'RDE',
        'SNM',
        'NGD',
        'NGA',
        'ADB',
        'NBA',
        'CBA',
        'CSA',
        'LGR',
        'BLA',
        'ABG',
        'BBC',
        'AGB',
        'OBG',
        'UNG',
        'BNZ',
        'ENE',
        'FUS',
        'UNK',
        'DDB',
        'DDD',
        'DDL',
        'DDC',
        'RED',
        'XPR',
        'BAM',
        'BAN',
        'BPA',
        'BPR',
        'EEI',
        'FRD',
        'IPA',
        'IPC',
        'IPE',
        'ISA',
        'RBC',
        'REC',
    ],
};
